import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const LP01 = lazy(() => import('../pages/lp01/page'));
const ShippingPolicy = lazy(() => import('../pages/shipping-policy/page'));
const ReturnsRefund = lazy(() => import('../pages/returns-refund/page'));
const AboutUs = lazy(() => import('../pages/about-us/page'));
const ContactUs = lazy(() => import('../pages/contact-us/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfService = lazy(() => import('../pages/terms-of-service/page'));
const VelaWarm = lazy(() => import('../pages/vela-warm/page'));
const VelaWarmPrivacy = lazy(() => import('../pages/vela-warm-privacy/page'));
const VelaWarmTerms = lazy(() => import('../pages/vela-warm-terms/page'));
const VelaWarmShipping = lazy(() => import('../pages/vela-warm-shipping/page'));
const VelaWarmReturns = lazy(() => import('../pages/vela-warm-returns/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/lp01',
    element: <LP01 />,
  },
  {
    path: '/shipping-policy',
    element: <ShippingPolicy />,
  },
  {
    path: '/returns-refund',
    element: <ReturnsRefund />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '/about-us',
    element: <AboutUs />,
  },
  {
    path: '/contact-us',
    element: <ContactUs />,
  },
  {
    path: '/vela-warm',
    element: <VelaWarm />,
  },
  {
    path: '/vela-warm-privacy',
    element: <VelaWarmPrivacy />,
  },
  {
    path: '/vela-warm-terms',
    element: <VelaWarmTerms />,
  },
  {
    path: '/vela-warm-shipping',
    element: <VelaWarmShipping />,
  },
  {
    path: '/vela-warm-returns',
    element: <VelaWarmReturns />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
